module.exports ={
    devURL: process.env.REACT_APP_DEV_BANKEND_PORT+'/api',
    prodURL:process.env.REACT_APP_PROD_BANKEND_PORT+'/api',
};